/* eslint-disable react/display-name */
import React from 'react'
import Link from './link'
import ProgressBar from 'react-bootstrap/ProgressBar'
import SvgArrow from './svg/arrow'
import { getOrderedMenuSections } from '../utils/menu-order'

export default function YourGameSections(props) {
  const {
    data,
    hunt_status,
    isGnG,
    team,
    num_questions_complete,
    num_questions,
    q_points,
    q_possible_points,
    qCompletedClass,
    num_final_questions,
    num_final_questions_complete,
    final_q_points,
    final_q_possible_points,
    finalQCompletedClass,
    mm_points,
    mm_possible_points,
    mmCompletedClass,
    em_points,
    em_possible_points,
    emCompletedClass,
  } = props

  const sectionRenderers = {
    questions: () => (
      <div className={`card mx-4 px-1 mt-3`}>
        <div className={`card-body`}>
          {hunt_status == `started` ? (
            <Link to={isGnG ? `/questions/overview/` : `/questions/`} className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col-9">
                  <h3 className={`title h6 text-uppercase mb-1`}>
                    {data.hunt.questions_title ? data.hunt.questions_title : `Questions`}
                  </h3>
                </div>
                <div className="col-3 text-right arrow-wrap-dark">
                  <SvgArrow />
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  {data.hunt.max_question_points > 0 ? (
                    <ProgressBar
                      className={`${qCompletedClass}`}
                      now={(q_points / q_possible_points) * 100}
                      label={`${q_points}/${q_possible_points}`}
                      srOnly
                    />
                  ) : (
                    <ProgressBar
                      className={`${qCompletedClass}`}
                      now={(num_questions_complete / num_questions) * 100}
                      label={`${num_questions_complete}/${num_questions}`}
                      srOnly
                    />
                  )}
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {q_points}/{q_possible_points} pts
                  </div>
                </div>
              </div>
            </Link>
          ) : (
            <div className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col">
                  <h3 className={`title h6 text-uppercase mb-1`}>
                    {data.hunt.questions_title ? data.hunt.questions_title : `Questions`}
                  </h3>
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${qCompletedClass}`}
                    now={(num_questions_complete / num_questions) * 100}
                    label={`${num_questions_complete}/${num_questions}`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {q_points}/{q_possible_points} pts
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    ),

    final_questions: () => (
      <div className={`card mx-4 px-1 mt-3`}>
        <div className={`card-body`}>
          {hunt_status == `started` ? (
            <Link to={`/questions/final/`} className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col-9">
                  <h3 className={`title h6 text-uppercase mb-1`}>
                    {data.hunt.secondary_questions_title ? data.hunt.secondary_questions_title : `Final Questions`}
                  </h3>
                </div>
                <div className="col-3 text-right arrow-wrap-dark">
                  <SvgArrow />
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${finalQCompletedClass}`}
                    now={(num_final_questions_complete / num_final_questions) * 100}
                    label={`${num_final_questions_complete}/${num_final_questions}`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {final_q_points}/{final_q_possible_points} pts
                  </div>
                </div>
              </div>
            </Link>
          ) : (
            <div className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col">
                  <h3 className={`title h6 text-uppercase mb-1`}>
                    {data.hunt.secondary_questions_title ? data.hunt.secondary_questions_title : `Final Questions`}
                  </h3>
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${finalQCompletedClass}`}
                    now={(num_final_questions_complete / num_final_questions) * 100}
                    label={`${num_final_questions_complete}/${num_final_questions}`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {final_q_points}/{final_q_possible_points} pts
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    ),

    answer_sheet: () => (
      <div className={`card mx-4 px-1 mt-3`}>
        <div className={`card-body`}>
          <Link to={`/answers/`} className={`overview-link d-block mb-0`}>
            <div className="row mb-2">
              <div className="col-9">
                <h3 className={`title h6 text-uppercase mb-1`}>
                  {data.hunt.answer_sheet_title ? data.hunt.answer_sheet_title : `Team Answer Sheet`}
                </h3>
              </div>
              <div className="col-3 text-right arrow-wrap-dark">
                <SvgArrow />
              </div>
            </div>
          </Link>
        </div>
      </div>
    ),

    checklists: () => (
      <div>
        {data.checklists.map(checklist => {
          let max_score = checklist.maximum_score
          let cur_score = 0
          if (
            team.checklist_answers !== undefined &&
                      team.checklist_answers !== null &&
                      team.checklist_answers[checklist.id] !== undefined
          ) {
            cur_score = team.checklist_answers[checklist.id].points
          }
          let completedClass = cur_score == max_score ? `completed` : ``
          return (
            <div key={checklist.id} className={`card mx-4 px-2 mt-3`}>
              {hunt_status == `started` ? (
                <Link to={`/checklists/#${checklist.id}`} className={`overview-link d-block card-body`}>
                  <div className="row">
                    <div className="col-9">
                      <h3 className={`title h6 text-uppercase`}> {checklist.display_title}</h3>
                    </div>
                    <div className="col-3 text-right arrow-wrap-dark">
                      <SvgArrow />
                    </div>
                  </div>
                  <div className="row no-gutters">
                    <div className="col-8">
                      <ProgressBar
                        className={`${completedClass}`}
                        now={(cur_score / max_score) * 100}
                        label={`${cur_score}/${max_score} pts`}
                        srOnly
                      />
                    </div>
                    <div className={`col-4 text-right arrow-wrap-dark`}>
                      <div className={`score`}>
                        {cur_score}/{max_score} pts
                      </div>
                    </div>
                  </div>
                </Link>
              ) : (
                <div className={`overview-link d-block card-body`}>
                  <div className="row">
                    <div className="col">
                      <h3 className={`title h6 text-uppercase`}> {checklist.display_title}</h3>
                    </div>
                  </div>
                  <div className="row no-gutters">
                    <div className="col-8">
                      <ProgressBar
                        className={`${completedClass}`}
                        now={(cur_score / max_score) * 100}
                        label={`${cur_score}/${max_score} pts`}
                        srOnly
                      />
                    </div>
                    <div className={`col-4 text-right arrow-wrap-dark`}>
                      <div className={`score`}>
                        {cur_score}/{max_score} pts
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        })}
      </div>
    ),

    bonus_challenge: () => (
      <div className={`card mx-4 px-1 mt-3`}>
        <div className={`card-body`}>
          <Link to={`/bonus-challenge/`} className={`overview-link d-block mb-0`}>
            <div className="row mb-2">
              <div className="col-9">
                <h3 className={`title h6 text-uppercase mb-1`}>
                  {data.hunt.bonus_challenge_title ? data.hunt.bonus_challenge_title : `Bonus Challenge`}
                </h3>
              </div>
              <div className="col-3 text-right arrow-wrap-dark">
                <SvgArrow />
              </div>
            </div>
          </Link>
        </div>
      </div>
    ),

    mystery_message: () => (
      <div className={`card mx-4 px-1 mt-3`}>
        <div className={`card-body`}>
          {hunt_status == `started` ? (
            <Link to={`/mystery-message/`} className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col-9">
                  <h3 className={`title h6 text-uppercase mb-1`}>Mystery Message</h3>
                </div>
                <div className="col-3 text-right arrow-wrap-dark">
                  <SvgArrow />
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${mmCompletedClass}`}
                    now={(mm_points / mm_points) * 100}
                    label={`${mm_points}/${mm_possible_points} pts`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {mm_points}/{mm_possible_points} pts
                  </div>
                </div>
              </div>
            </Link>
          ) : (
            <div className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col">
                  <h3 className={`title h6 text-uppercase mb-1`}>Mystery Message</h3>
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${mmCompletedClass}`}
                    now={(mm_points / mm_points) * 100}
                    label={`${mm_points}/${mm_possible_points} pts`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {mm_points}/{mm_possible_points} pts
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    ),

    emergency_message: () => (
      <div className={`card mx-4 px-1 mt-3`}>
        <div className={`card-body`}>
          {hunt_status == `started` ? (
            <Link to={`/emergency-message/`} className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col-9">
                  <h3 className={`title h6 text-uppercase mb-1`}>{data.emergency_message.display_title}</h3>
                </div>
                <div className="col-3 text-right arrow-wrap-dark">
                  <SvgArrow />
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${emCompletedClass}`}
                    now={(em_points / em_points) * 100}
                    label={`${em_points}/${em_possible_points} pts`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {em_points}/{em_possible_points} pts
                  </div>
                </div>
              </div>
            </Link>
          ) : (
            <div className={`overview-link d-block mb-0`}>
              <div className="row mb-2">
                <div className="col">
                  <h3 className={`title h6 text-uppercase mb-1`}>{data.emergency_message.display_title}</h3>
                </div>
              </div>

              <div className="row no-gutters">
                <div className="col-8">
                  <ProgressBar
                    className={`${emCompletedClass}`}
                    now={(em_points / em_points) * 100}
                    label={`${em_points}/${em_possible_points} pts`}
                    srOnly
                  />
                </div>
                <div className="col-4 text-right arrow-wrap-dark align-self-center">
                  <div className={`score`}>
                    {em_points}/{em_possible_points} pts
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    ),

  }

  return getOrderedMenuSections(data, { huntStatus: hunt_status, showQuestions: false }).map(sectionKey => (
    <React.Fragment key={sectionKey}>{sectionRenderers[sectionKey]()}</React.Fragment>
  ))
}
